// ------------- CONTENTS: --------------------------------------------
// - Move size picker below "What's included"
// - Scroll to "Pick your size first" on click
// - Shipping info above add to cart // UAE specific ≠ SG
// - Bundle items image zoom
// - PDP Tabs Content
// --------------------------------------------------------------------
// --------------------------------------------------------------------
// ***** Move size picker below "What's included"
// --------------------------------------------------------------------
document.addEventListener('DOMContentLoaded', () => {
  const variantPicker = document.querySelector('.product-block[data-dynamic-variants-enabled]');
  const whatsIncluded = document.querySelector('.bundle-included-wrapper');

  if (variantPicker && whatsIncluded) {
    whatsIncluded.insertAdjacentElement('afterend', variantPicker);
  }

  variantPicker.style.visibility = 'visible';
});
// --------------------------------------------------------------------
// ***** Scroll to "Pick your size first" on click
// --------------------------------------------------------------------
document.addEventListener('DOMContentLoaded', function () {
  var toggle = document.getElementById('bundle-atc-toggle');
  var warning = document.getElementById('bundle-size-warning');

  if (!toggle || !warning) return;

  toggle.addEventListener('click', function () {
    if (toggle.checked) {
      warning.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
        inline: 'nearest'
      });
    }
  });
});
// --------------------------------------------------------------------
// ***** Shipping info above add to cart // UAE specific ≠ SG
// --------------------------------------------------------------------
(function () {

  const box = document.querySelector('.delivery-message');
  if (!box) return;

  const nextMsg = box.querySelector('.delivery-message__next');
  const sameMsg = box.querySelector('.delivery-message__same');
  const underMsg = box.querySelector('.delivery-message__under');

  const next = parseInt(box.dataset.nextDay, 10);
  const same = parseInt(box.dataset.sameDay, 10);

  function getPrice() {
    const el = document.querySelector('[data-product-price-cents]');
    if (!el) return null;
    const price = parseInt(el.dataset.productPriceCents, 10);
    return isNaN(price) ? null : price;
  }

  function hideAll() {
    if (nextMsg) nextMsg.hidden = true;
    if (sameMsg) sameMsg.hidden = true;
    if (underMsg) underMsg.hidden = true;
  }

  function updateMessages() {

    const price = getPrice();
    if (price === null) return;

    hideAll();

    if (price >= same) {
      if (sameMsg) sameMsg.hidden = false;
    }
    else if (price >= next) {
      if (nextMsg) nextMsg.hidden = false;
    }
    else {
      if (underMsg) underMsg.hidden = false;
    }

    box.hidden = false;
  }

  function positionBox() {

    const targets = [
      '.gfbFrequentBoughtAddToCartButtonSection',
      '.gpo-container + button.add-to-cart',
      '.custom--add-to-cart button.add-to-cart.btn--secondary',
      '.custom--add-to-cart button.add-to-cart'
    ];

    for (const selector of targets) {
      const target = document.querySelector(selector);
      if (target && target.parentNode) {
        target.parentNode.insertBefore(box, target);
        break;
      }
    }
  }

  document.addEventListener('variant:changed', updateMessages);
  document.addEventListener('product:variant-change', updateMessages);

  document
    .querySelector('select[name="id"]')
    ?.addEventListener('change', updateMessages);

  updateMessages();
  positionBox();

})();
// --------------------------------------------------------------------
// --------------------------------------------------------------------
// ***** Bundle items image zoom
// --------------------------------------------------------------------
(function($){
  'use strict';
  // Image containers that should trigger tooltip
  var IMAGE_SELECTOR = '.bundle-included__image';
  
  // Cache media query
  var isMobileDevice = window.matchMedia('(hover: none)');
  var isMobile = function(){ return isMobileDevice.matches; };
  
  // Debounce helper
  function debounce(fn, delay){
    var timer = null;
    return function(){
      var ctx = this, args = arguments;
      clearTimeout(timer);
      timer = setTimeout(function(){ fn.apply(ctx, args); }, delay);
    };
  }
  
  // Position tooltip for desktop
  function positionTooltip($box, evt){
    if ($box.hasClass('is-mobile')) return;
    
    var pad = 16;
    var tw = $box.outerWidth();
    var th = $box.outerHeight();
    var vw = window.innerWidth;
    var vh = window.innerHeight;
    
    var x = evt.clientX + pad;
    var y = evt.clientY + pad;
    
    // Prevent overflow
    if (x + tw > vw) x = evt.clientX - tw - pad;
    if (y + th > vh) y = evt.clientY - th - pad;
    
    // Ensure it stays on screen
    x = Math.max(pad, Math.min(x, vw - tw - pad));
    y = Math.max(pad, Math.min(y, vh - th - pad));
    
    $box.css({ left: x + 'px', top: y + 'px' });
  }
  
  // Debounced version for mousemove
  var debouncedPosition = debounce(positionTooltip, 10);
  
  // Get or create tooltip
  var $tip = $('#img-tooltip');
  if (!$tip.length) {
    $tip = $('<div>', {
      id: 'img-tooltip',
      class: 'img-tooltip',
      'aria-hidden': 'true',
      'role': 'tooltip'
    }).append($('<img>', { alt: 'Product preview' }));
    $('body').append($tip);
  }
  var $tipImg = $tip.find('img');

  // Guard to ignore immediate close right after open (mobile)
  var lastOpenAt = 0;
  function justOpened() { return Date.now() - lastOpenAt < 300; }
  
  // Set image source with validation
  function setTipSrcFrom($img){
    var url = $img.attr('src');
    if (!url) return false;
    
    // Handle protocol-relative URLs
    if (url.indexOf('//') === 0) {
      url = window.location.protocol + url;
    }
    
    // Only update if different
    if ($tipImg.attr('src') !== url) {
      $tipImg.attr('src', url);
    }
    return true;
  }
  
  // Show tooltip
  function showTooltip($img, mobile){
    if (!setTipSrcFrom($img)) return false;
    
    $tip.toggleClass('is-mobile', mobile)
        .css(mobile ? { left: '', top: '' } : {})
        .show()
        .attr('aria-hidden', 'false');

    // Mark open time on mobile to prevent immediate close
    if (mobile) lastOpenAt = Date.now();
    
    return true;
  }
  
  // Hide tooltip
  function hideTooltip(){
    $tip.hide().attr('aria-hidden', 'true');
  }
  
  // ===== Desktop (hover) =====
  $(document)
    .on('mouseenter', IMAGE_SELECTOR, function(e){
      if (isMobile()) return;
      
      var $img = $(this).find('img').first();
      if (showTooltip($img, false)) {
        positionTooltip($tip, e);
      }
    })
    .on('mousemove', IMAGE_SELECTOR, function(e){
      if (isMobile() || !$tip.is(':visible')) return;
      debouncedPosition($tip, e);
    })
    .on('mouseleave', IMAGE_SELECTOR, function(){
      if (isMobile()) return;
      hideTooltip();
    });
  
  // ===== Mobile (touch) =====
  // Use a flag to prevent double-firing
  var touchHandled = false;
  
  $(document).on('touchstart', IMAGE_SELECTOR, function(e){
    if (!isMobile()) return;
    
    e.preventDefault();
    e.stopPropagation();
    touchHandled = true;
    
    var $img = $(this).find('img').first();
    showTooltip($img, true);
    
    // Reset flag after a short delay
    setTimeout(function(){ touchHandled = false; }, 300);
  });
  
  // Fallback for devices that fire click on touch
  $(document).on('click', IMAGE_SELECTOR, function(e){
    if (!isMobile() || touchHandled || $tip.is(':visible')) return;
    
    e.preventDefault();
    e.stopPropagation();
    
    var $img = $(this).find('img').first();
    showTooltip($img, true);
  });
  
  // Guard to ignore immediate close right after open (mobile)
  var lastOpenAt = 0;
  function justOpened() { return Date.now() - lastOpenAt < 300; }
  
  // Close tooltip on tap INSIDE tooltip
  $(document).on('touchstart', '#img-tooltip', function(e){
    if (!isMobile()) return;
    if (justOpened()) { e.preventDefault(); e.stopPropagation(); return; }
    e.preventDefault();
    e.stopPropagation();
    hideTooltip();
  });
  
  $(document).on('click', '#img-tooltip', function(e){
    if (isMobile()) return; // desktop only
    e.preventDefault();
    e.stopPropagation();
    hideTooltip();
  });
  
  // Close on outside tap (mobile only)
  $(document).on('touchstart', function(e){
    if (!isMobile() || !$tip.is(':visible')) return;
    if (justOpened()) return; // guard against same gesture
    
    var $target = $(e.target);
    var isInside = $target.closest('#img-tooltip').length || 
                   $target.closest(IMAGE_SELECTOR).length;
    
    if (!isInside) hideTooltip();
  });
  
  // Keyboard support: ESC to close
  $(document).on('keydown', function(e){
    if (e.key === 'Escape' && $tip.is(':visible')) {
      hideTooltip();
    }
  });
  
  // Handle window resize
  var resizeTimer;
  $(window).on('resize', function(){
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function(){
      if ($tip.is(':visible') && !$tip.hasClass('is-mobile')) {
        hideTooltip();
      }
    }, 250);
  });
  
})(window.jQuery || window.$);
// --------------------------------------------------------------------
// --------------------------------------------------------------------
// ***** PDP Tabs Content
// --------------------------------------------------------------------
(function () {
  var TAB_SELECTOR = '[data-pdp-tab]';
  var TABS_CONTAINER_SELECTOR = '[data-pdp-tabs-container]';

  function initPdpTabs() {
    var tabsContainer = document.querySelector(TABS_CONTAINER_SELECTOR);
    if (!tabsContainer) return;

    var tabCandidates = Array.prototype.slice.call(
      document.querySelectorAll(TAB_SELECTOR)
    );

    // We need at least 2 tabs to justify the UI
    if (tabCandidates.length < 2) return;

    var nav = tabsContainer.querySelector('.pdp-tabs__nav');
    var content = tabsContainer.querySelector('.pdp-tabs__content');

    if (!nav || !content) return;

    // Clear in case of partial DOM re-render
    nav.innerHTML = '';
    content.innerHTML = '';

    tabCandidates.forEach(function (el, index) {
      var rawLabel = el.getAttribute('data-tab-label');
      var label =
        (rawLabel && rawLabel.trim()) ||
        extractHeading(el) ||
        'Tab ' + (index + 1);

      var tabId = 'pdp-tab-' + index;

      // Create nav button
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'pdp-tabs__nav-item';
      btn.textContent = label;
      btn.setAttribute('data-tab-target', tabId);

      if (index === 0) btn.classList.add('is-active');

      nav.appendChild(btn);

      // Prepare content
      el.classList.add('pdp-tabs__panel');
      el.setAttribute('data-tab-panel', tabId);

      if (index !== 0) {
        el.style.display = 'none';
      }

      content.appendChild(el);
    });

    // Activate tabs container
    tabsContainer.hidden = false;

    bindTabEvents(tabsContainer);
  }

  function bindTabEvents(tabsContainer) {
    var navItems = tabsContainer.querySelectorAll('.pdp-tabs__nav-item');
    var panels = tabsContainer.querySelectorAll('[data-tab-panel]');

    navItems.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var target = btn.getAttribute('data-tab-target');

        navItems.forEach(function (b) {
          b.classList.toggle('is-active', b === btn);
        });

        panels.forEach(function (panel) {
          panel.style.display =
            panel.getAttribute('data-tab-panel') === target ? '' : 'none';
        });
      });
    });
  }

  function extractHeading(container) {
    var heading = container.querySelector('h1, h2, h3, h4');
    return heading ? heading.textContent.trim() : null;
  }

  // Init on DOM ready
  document.addEventListener('DOMContentLoaded', initPdpTabs);
})();
